import React from "react"
import * as S from "./Text.styles"

export default function Text({ children, ...rest }) {
  return <S.Text {...rest}>{children}</S.Text>
}
